import React from 'react';
import { Head } from '@inertiajs/react';
import PostShow from '@/components/admin/blog/PostShow';

interface Post {
  id: number;
  title: string;
  slug: string;
  summary: string;
  content: string;
  content_html: string;
  ai_markdown: string;
  tiptap_json: Record<string, unknown>;
  status: 'draft' | 'published' | 'archived';
  visibility: 'visible' | 'auth_only';
  published_at: string | null;
  created_at: string;
  updated_at: string;
  author: {
    id: number;
    name: string;
    email: string;
  };
  categories: Array<{ id: number; name: string; slug: string }>;
  tags: Array<{ id: number; name: string; slug: string }>;
}

interface Props {
  post: Post;
}

const Show: React.FC<Props> = ({ post }) => {
  return (
    <>
      <Head title={post.title} />
      <PostShow post={post} canEdit={true} />
    </>
  );
};

export default Show;
